import { ChevronDownOutlined as ChevronDownRegularIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ChevronDownOutlined";
import { ChevronUpOutlined as ChevronUpRegularIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ChevronUpOutlined";
import { UnderlinedButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/Button";
import { useRouter } from "next/router";
import Link from "next/link";
import PropTypes from "prop-types";
import React, { Fragment, useState } from "react";
import { dispatchNewEvent } from "../../utils/analytics/trigger/analyticsTrigger";
import InfoBox from "../info-box/InfoBox";
import SlideIn from "../slide-in/SlideIn";
import styles from "./conatct-us-complaints-and-escalations.module.scss";

function ContactUsComplaintsAndEscalations({ contactDetails: { online } }) {
  const router = useRouter();
  const [complaintDetailsExpanded, setComplaintDetailsExpanded] = useState(false);

  const toggleComplaintDetails = () => {
    setComplaintDetailsExpanded(!complaintDetailsExpanded);
  };

  const toggleEscalationDetails = () => {
    router.push("./escalated-complaints");
  };

  const handlePhoneClick = (number, type) => () => {
    dispatchNewEvent("dataStateChange", {
      action: "contactNumberClicked",
      type,
      phoneNumber: number,
    });
  };

  const renderDisplayTimes = displayTimes => (
    <span>
      {displayTimes.map(oTime => (
        <Fragment key={oTime.days}>
          {oTime.days === "7 days a week" ? `${oTime.times}, ${oTime.days}` : `${oTime.days}, ${oTime.times}`}
        </Fragment>
      ))}
    </span>
  );

  const getComplaintsDetailsBox = (
    <SlideIn>
      <InfoBox className={styles.complaints_details_box}>
        <p>Our team will get to the bottom of your issue and help put things right.</p>
        <p>
          Just <Link href="/email-us?source=contact-us | complaints | website">email us</Link> or call on{" "}
          <a
            className={styles.complaint_contact_phone_link}
            href={`tel:${online.phone.number}`}
            onClick={handlePhoneClick}
          >
            <strong>{online.phone.number}</strong>
          </a>{" "}
          {renderDisplayTimes(online.phone.displayTimes)}.
        </p>
        <p className={styles.no_margin}>
          If you are still unhappy with our response, you can{" "}
          <UnderlinedButton onClick={toggleEscalationDetails} className={styles.expand_link}>
            escalate your issue
          </UnderlinedButton>
          .
        </p>
      </InfoBox>
    </SlideIn>
  );

  return (
    <div className={styles.complaints_area}>
      <h4>Complaints process</h4>
      <div>
        <UnderlinedButton onClick={toggleComplaintDetails} className={styles.expand_link}>
          <span>{complaintDetailsExpanded ? "Escalate process" : "Find out more"}</span>
          {complaintDetailsExpanded ? <ChevronUpRegularIcon /> : <ChevronDownRegularIcon />}
        </UnderlinedButton>
      </div>
      {complaintDetailsExpanded ? getComplaintsDetailsBox : null}
    </div>
  );
}

ContactUsComplaintsAndEscalations.propTypes = {
  contactDetails: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    online: PropTypes.object,
  }),
};

ContactUsComplaintsAndEscalations.defaultProps = {
  contactDetails: {},
};

export default ContactUsComplaintsAndEscalations;
